module.exports = __webpack_public_path__ + "img/home-parallax.b73bc15f.jpg";